exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".document-page[data-v-64131514]{height:90vh;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.splitpanes.default-theme[data-v-64131514]{-webkit-box-flex:1;-ms-flex:1;flex:1;height:100%}.pane-scroll[data-v-64131514]{height:100%}", ""]);

// exports
